<template>
  <div class="page-information">
    <div class="information-search">
      <span class="search-label">资讯名称：</span>
      <el-input
        class="search-input"
        size="small"
        v-model="infoName"
        placeholder="请输入内容"
      ></el-input>
      <el-button
        class="search-but1"
        size="small"
        type="primary"
        @click="handleSearch"
      >
        搜索
      </el-button>
      <el-button class="search-but1" size="small" @click="handleReset">
        重置
      </el-button>
    </div>
    <div class="information-tag">
      <el-tag
        class="tag-item"
        size="medium"
        v-for="item in tagList"
        :key="item.label"
        :effect="classifyId === item.value ? 'dark' : 'light'"
        @click="handleTag(item.value)"
      >
        {{ item.label }}
      </el-tag>
    </div>
    <div class="information-add">
      <el-button size="small" type="primary" @click="handleAdd">
        新建
      </el-button>
      <el-button size="small" type="text">
        资讯列表地址:
        <a v-if="[6, 7, 8, 20].includes(classifyId)" :href="`${domainUrl}/careerMatrix/${classifyId}`" target="_blank">{{ `${domainUrl}/careerMatrix/${classifyId}` }}</a>
        <a v-else :href="`${domainUrl}/publicInformationList?classifyId=${classifyId}`" target="_blank">{{ `${domainUrl}/publicInformationList?classifyId=${classifyId}` }}</a>
      </el-button>
    </div>
    <div class="information-table">
      <el-table
        :data="informationList"
        style="width: 100%"
        :border="true"
        v-loading="loading"
        row-key="id"
      >
        <el-table-column
          v-for="item in column"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :min-width="item.width || '100'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'infoName'">
              <a href="javascript:;" @click="openDetail(scope.row)">{{ scope.row.infoName }}</a>
            </template>
            <template v-else-if="item.prop === 'linkUrl'">
              <span v-if="scope.row.state === 2">
                {{ `${domainUrl}/publicInformationDetail?classifyId=${classifyId}&id=${scope.row.id}` }}
              </span>
            </template>
            <template v-else-if="item.prop === 'infoImg' && scope.row.infoImg">
              <img
                class="table-img"
                :src="scope.row.infoImg"
                alt="资讯封面"
                @click="lookBigImg(scope.row)"
              />
            </template>
            <template v-else-if="item.prop !== 'infoImg'">
              {{ tableTranslation(item.prop, scope.row) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="180"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.state === 2"
              @click="handleCancelTop(scope.row)"
            >
              {{ scope.row.topFlag === 2 ? '取消置顶' : '置顶' }}
            </el-button>
            <el-button type="text" @click="handleStatus(scope.row)">
              {{ scope.row.state === 2 ? '下架' : '发布' }}
            </el-button>
            <el-button type="text" @click="handleEditor(scope.row)">
              编辑
            </el-button>
            <el-button v-if="scope.row.state !== 2" type="text" @click="handleType(scope.row)">
              移动
            </el-button>
            <el-button
              v-if="scope.row.state === 1"
              type="text"
              @click="handleDel(scope.row)"
            >
              删除
            </el-button>
            <el-button
              type="text"
              @click="handleCopy(scope.row)"
            >
              复制到其他栏目
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="information-pagination">
      <el-pagination
        @size-change="handleLimitChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <WriteDialog
      v-if="writeDialogFlag"
      :dialogTitle="writeDialogTitle"
      :handleClose="handleCloseWriteDialog"
      :close="close"
      :defaultData="writeDialogData"
      :classifyId="classifyId"
    />
    <PublicShowImg ref="showImgRef" />
    <InformationPreview
      v-if="previewFlag"
      :handleClose="handCloseDetail"
      :viewData="row"
    />

    <el-dialog
      title="移动资讯"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose1">
      将{{ typeRow.infoName }}资讯移动至 <el-select v-model="typeRow.type">
        <el-option v-for="item in tagList" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose1">取 消</el-button>
        <el-button type="primary" @click="updateType">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="复制到其他栏目"
      :visible.sync="dialogVisibleCopy"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseCopy">
      <el-form ref="formCopyEl" :model="formCopy" :rules="formCopyRules" label-width="138px">
        <el-form-item label="资讯名称: ">
          <p class="form-item-text">{{ targetRow.infoName }}</p>
        </el-form-item>
        <el-form-item label="原资讯发布时间: ">
          <p class="form-item-text">{{ targetRow.publishTime }}</p>
        </el-form-item>
        <el-form-item label="操作人: ">
          <p class="form-item-text">{{ targetRow.insertName }}</p>
        </el-form-item>
        <el-form-item label="选择栏目: " prop="classifyIds">
          <el-select v-model="formCopy.classifyIds" multiple collapse-tags clearable style="width: 200px">
            <el-option v-for="item in tagListFilter" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="发布时间: " prop="publishTime">
          <el-row type="flex">
            <el-date-picker
              v-model="formCopy.publishTime"
              type="datetime"
              placeholder="选择发布时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 200px"
            />&emsp;
            <el-button type="text" @click="formCopy.publishTime = targetRow.publishTime">使用相同时间</el-button>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCopy">取 消</el-button>
        <el-button type="primary" @click="updateCopy">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import * as API from '../../api/information/index'
import { column, tagList } from './assets'
import WriteDialog from './writeDialog.vue'
import InformationPreview from './preview.vue'
import PublicShowImg from '../swiperManage/openImg.vue'
export default {
  name: 'InformationManage',
  components: { WriteDialog, PublicShowImg, InformationPreview },
  props: {
    tag: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      infoName: '',
      classifyId: this.tag && this.tag.length ? 6 : 1,
      column,
      informationList: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,
      writeDialogFlag: false,
      writeDialogTitle: '',
      writeDialogData: {},
      previewFlag: false,
      row: null,
      dialogVisible: false,
      typeRow: {
        infoName: '',
        type: ''
      },
      dialogVisibleCopy: false,
      targetRow: {},
      formCopy: {
        classifyIds: [],
        publishTime: ''
      },
      formCopyRules: {
        classifyIds: [{ required: true, message: "请选择栏目!", trigger: "change" }],
        publishTime: [{ required: true, message: "请选择发布时间!", trigger: "change" }]
      }
    }
  },
  computed: {
    domainUrl () {
      if (process.env.VUE_APP_CURRENTMODE === 'prod') {
        return 'https://www.nrtatalent.cn'
      }
      return 'http://tvpc.shenlakaoyan.com'
    },
    tagList () {
      if (this.tag.length) {
        return this.tag
      }
      return tagList
    },
    tagListFilter () {
      let r = this.tagList.filter(({ value }) => value !== this.classifyId)
      if (this.targetRow && this.targetRow.classifyIds) {
        r = r.filter(({ value }) => this.targetRow.classifyIds.indexOf(value + '') === -1)
      }
      return r
    }
  },
  created() {
    this.getInformationList()
  },
  methods: {
    openDetail(row) {
      this.row = row
      this.previewFlag = true
    },
    handCloseDetail() {
      this.previewFlag = false
    },
    handleType(row) {
      this.typeRow = {...row}
      this.dialogVisible = true
    },
    handleClose1() {
      this.dialogVisible = false
      this.typeRow = {
        infoName: '',
        type: ''
      }
    },
    async updateType () {
      const res = await API.updateType({ id: this.typeRow.id, type: this.typeRow.type })
      this.$message.success('操作成功!')
      this.handleClose1()
      this.getInformationList()
    },
    // 获取资讯列表
    async getInformationList() {
      this.loading = true
      const { page, limit, classifyId, infoName } = this
      const params = { page, limit, classifyId, infoName }
      try {
        const res = await API.getInformationList(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.informationList = records.map((item, ind) => ({
            ...item,
            sortNum: (page - 1) * limit + ind + 1
          }))
          this.total = Number(total)
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    // 切换资讯类型
    handleTag(ind) {
      this.page = 1
      this.classifyId = ind
      this.getInformationList()
    },
    // 表格单元格转换
    tableTranslation(key, row) {
      switch (key) {
        case 'state':
          switch (row[key]) {
            case 0:
              return '未发布'
            case 1:
              return '已下架'
            case 2:
              return '已发布'
            default:
              return ''
          }
        case 'topFlag':
          if (row['state'] === 2) {
            switch (row[key]) {
              case 1:
                return '未置顶'
              case 2:
                return '已置顶'
              default:
                return ''
            }
          } else {
            return '-'
          }
        case 'attachFlage':
          switch (row[key]) {
            case 0:
              return '否'
            case 1:
              return '是'
            default:
              return ''
          }
        default:
          return row[key]
      }
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getInformationList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getInformationList()
    },
    // 搜索
    handleSearch() {
      this.page = 1
      this.getInformationList()
    },
    // 重置
    handleReset() {
      this.page = 1
      this.limit = 10
      this.infoName = ''
      this.getInformationList()
    },
    // 表格操作项点击取消置顶
    async handleCancelTop(row) {
      try {
        const res = await API.topInformation(row.id)
        const { code } = res
        if (code === 0) {
          this.getInformationList()
        }
      } catch (error) {}
    },
    // 单元格点击查看封面大图
    lookBigImg(row) {
      const { infoImg, infoName } = row
      this.$refs.showImgRef.show(infoImg, infoName)
    },
    // 表格操作项点击编辑
    handleEditor(row) {
      this.writeDialogTitle = '编辑资讯'
      this.writeDialogData = row
      this.writeDialogFlag = true
    },
    // 表格操作项点击删除
    handleDel(row) {
      const { id, infoName } = row
      this.$confirm(`确认要删除${infoName}吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const res = await API.delInformation(id)
          const { code } = res
          if (code === 0) {
            this.getInformationList()
          }
        })
        .catch(() => {})
    },
    // 表格操作项点击发布、下架
    handleStatus(row) {
      const { id, infoName, state } = row
      this.$confirm(`确认要${state === 2 ? '下架' : '发布'}${infoName}吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const res = await API.stateformation(id)
          const { code } = res
          if (code === 0) {
            this.getInformationList()
          }
        })
        .catch(() => {})
    },
    close(bool) {
      this.writeDialogFlag = false
      switch (bool) {
        case 'reset':
          this.handleReset()
          break
        case 'update':
          this.getInformationList()
          break
        default:
          break
      }
    },
    // 新建、编辑资讯弹框关闭
    handleCloseWriteDialog(bool, infoTitle) {
      if (infoTitle && infoTitle !== '<p><br></p>') {
        this.$confirm('此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.close(bool)
        }).catch(() => {});
      } else {
        this.close(bool)
      }
    },
    // 新建资讯
    handleAdd() {
      this.writeDialogTitle = '新建资讯'
      this.writeDialogData = {}
      this.writeDialogFlag = true
    },
    handleCopy (row) {
      this.targetRow = row
      this.dialogVisibleCopy = true
    },
    updateCopy () {
      this.$refs.formCopyEl.validate(valid => {
        if (valid) {
          const params = {
            id: this.targetRow.id,
            classifyIds: this.formCopy.classifyIds.join(','),
            publishTime: this.formCopy.publishTime
          }
          API.copyInformation(params).then(({ code }) => {
            if (code === 0) {
              this.$message.success('复制成功!')
              this.handleCloseCopy()
            }
          })
        }
      })
    },
    handleCloseCopy () {
      this.$refs.formCopyEl && this.$refs.formCopyEl.resetFields()
      this.targetRow = this.$options.data().targetRow
      this.formCopy = this.$options.data().formCopy
      this.dialogVisibleCopy = false
    }
  }
}
</script>
<style lang='scss' scoped>
.page-information {
  background: #fff;
  padding: 20px;
  .information-search {
    margin-bottom: 20px;
    .search-label {
      margin-right: 10px;
    }
    .search-input {
      width: 230px;
      margin-right: 100px;
    }
    .search-but1 {
      margin-right: 10px;
    }
    .search-but2 {
      margin-right: 10px;
    }
  }
  .information-tag {
    margin-bottom: 20px;
    .tag-item {
      cursor: pointer;
    }
  }
  .information-add {
    margin-bottom: 20px;
  }
  .information-table {
    margin-bottom: 20px;
    .table-img {
      width: 100px;
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>
